import React from "react";
import { NavLink } from "react-router-dom";
import { Html2CanvasFunction } from "../../utils/NewHelper";
import Loader from "../loader/loader";

import { showCongratulations } from "../../utils/misc";
import { onImageFileUploaded } from "../../utils/helper";
import Mantra_25_New_Canvas from "./Mantra_25_New_Canvas";

class Mantra_25_New_Edit extends React.Component {
  constructor() {
    super();
    this.state = {
      step1: null,
      step2: null,
      step3: null,
      step4: null,
      step5: null,
      step6: null,
      step7: null,
      step8: null,
      isLoading: false,
    };
  }

  postData = async () => {
    // e.preventDefault();
    this.setState({
      isLoading: true,
    });

    if (
      this.state.step1 &&
      this.state.step2 &&
      this.state.step3 &&
      this.state.step4 &&
      this.state.step5 &&
      this.state.step6 &&
      this.state.step7 &&
      this.state.step8
    ) {
      //canvas this means canvas is all set, read the name and festival and generate canvas now
      // $(".preloader_mantra").show();
      var ref = this;
      let reqdata = {
        type: ref.props.type,
        module_name: ref.props.module_name,
      };
      let resData = await Html2CanvasFunction(reqdata);
      resData.addEventListener("load", function (data) {
        data = resData.response;
        data = JSON.parse(data);
        var imageUrl = data.data.cardimage;
        var id = data.data.id;
        ref.setState(
          {
            shareData: imageUrl,
            id: id,
            image: null,
            isLoading: false,
          },
          () => {
            showCongratulations(ref.props.module_name);
          }
        );

        ref.props.onCanVase(imageUrl, id);
        // ref.processShare(data, params, ref);
        onImageFileUploaded({
          image: imageUrl,
          module: ref.props.module_name,
          postid: id,
        });
      });
    } else {
      alert("All Fields are required.");
      this.setState({
        isLoading: false,
      });
    }
  };

  setVlaue = (e) => {
    const { value, name } = e.target;
    if (value.length <= 100) {
      this.setState({
        [name]: value.substring(0,30),
      });
    }
  };

  render() {
    const {
      step1,
      step2,
      step3,
      step4,
      step5,
      step6,
      step7,
      step8,
      isLoading,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }
    return (
      <>
        <div className="m3_a1_container container">
          <div className="">
            <div className="m3_p_img_prev">
              <span>Preview</span>
            </div>

            <section className="mantra25b_prev_section">
            <img src="/assets/img/mantra_6_icon.png" class="mn6_ic" alt=""/>
              <img src="/assets/img/Mantra_25b.jpg" className="m3a1_img" />
              <span className="m25b_txt1">{step1} </span>
              <span className="m25b_txt2">{step2} </span>
              <span className="m25b_txt3">{step3} </span>
              <span className="m25b_txt4">{step4} </span>
              <span className="m25b_txt5">{step5} </span>
              <span className="m25b_txt6">{step6} </span>
              <span className="m25b_txt7">{step7} </span>
              <span className="m25b_txt8">{step8} </span>
            </section>
            {/* <img src="/assets/img/mantra3_form.png" className="m3a1_img" /> */}
          </div>
          <section className="m3_form">
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day1.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step1}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step1"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day2.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step2}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step2"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day3.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step3}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step3"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day4.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step4}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step4"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day5.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step5}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step5"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day6.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step6}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step6"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day7.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step7}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step7"
              />
            </div>
            <div className="m3_form_group">
              <label className="m3_label"><img src="/assets/img/em_day8.jpg" className="em_25"/> *</label>
              <input
                className="m3_input active"
                value={step8}
                onChange={(e) => {
                  this.setVlaue(e);
                }}
                type="text"
                name="step8"
              />
            </div>
            <button className="btn_f" onClick={() => this.postData()}>
              Done & Share
            </button>
          </section>
        </div>

        {step1 &&
          step2 &&
          step3 &&
          step4 &&
          step5 &&
          step6 &&
          step7 &&
          step8 && (
            <Mantra_25_New_Canvas
              {...this.state}
              module_name={this.props.module_name}
            />
          )}
      </>
    );
  }
}

export default Mantra_25_New_Edit;
